import { UserKind } from './user-kind';

export class SecurityInfosModel {
  roles: number;
  userKind: UserKind|null;
  isSupport: boolean;
}
